/* Question — RJ-12 (Bible §22 · Q5 locked).
   The five locked types. Validation blocks publish on empty answers, and the
   question is versioned with the demande it belongs to. Free text stays
   optional and short: small cohorts are masked in reporting.
   Batch 10 (F-10): « Passer » is not a merchant switch — every question is
   skippable, always, and the gift opens whatever the customer answers. */
import { useState } from 'react'
import { Field, Input, KV, Note } from '@/ui'
import { Retour, Verrouille } from './parts'

const TYPES = ['Choix unique', 'Choix multiples', 'Oui / non', 'Échelle 1–5', 'Texte libre']
const REPONSES = ['Des créneaux le soir', 'Un rappel au bon moment', 'Des offres sur les soins']

export default function Question() {
  const [type, setType] = useState(TYPES[0])

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 700 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
        <span className="f-help">Quiz /</span>
        <h2 className="t-page" style={{ margin: 0 }}>Question 1</h2>
      </div>

      <div>
        <span className="f-label">Type</span>
        <div className="tabs">
          {TYPES.map(t => (
            <button key={t} type="button" className={'tab' + (type === t ? ' on' : '')}
              onClick={() => setType(t)}>{t}</button>
          ))}
        </div>
      </div>

      <Field label="Question">
        {id => <Input id={id} defaultValue="Qu’est-ce qui vous ferait revenir plus souvent ?" />}
      </Field>

      <div>
        <span className="f-label">Réponses</span>
        <div style={{ display: 'grid', gap: 6 }}>
          {REPONSES.map((r, i) => <Input key={i} defaultValue={r} aria-label={`Réponse ${i + 1}`} />)}
        </div>
      </div>

      <KV rows={[['« Passer » sur cette question',
        <span key="p" style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
          toujours affiché <Verrouille />
        </span>],
      ['Ce qui se passe si le client passe', 'la question suivante, puis le cadeau — le tirage a eu lieu au scan']]} />

      <Note tone="candour">
        Le texte libre reste facultatif et court — évitez de demander des informations
        sensibles&nbsp;; les petites cohortes sont masquées dans les rapports.
      </Note>
    </div>
  )
}
